<div class="campaign-selection-shell column-layout start-aligned">
    <div *ngIf="clientsData.length > 1" class="client-record-selection">
        <label class="campaign-selection__filter-label">{{ 'FILTER_BY_CLIENT_RECORD' | translate }}</label>
        <ng-select 
            #clientSelect
            class="client-select" 
            [items]="clientsData" 
            bindLabel="fullName" 
            bindValue="id"
            [ngModel]="clientFilter.id"
            (ngModelChange)="onClientChangeById($event, clientSelect)"
            (clear)="onClientClear(clientSelect)">
        </ng-select>
    </div>
    <ng-container>
        <div class="cart-wizard-section-divider">
            <strong class="cart-wizard-section-divider__title">{{ 'CREATE_OR_REACTIVATE_PREVIOUS_CAMPAIGNS' | translate }}</strong>
            <p class="cart-wizard-section-divider__copy">{{ 'INACTIVE_LOCATIONS_TIP' | translate }}</p>
        </div>
        <div class="campaign-container">
            <ng-container *ngFor="let item of selectableCampaigns">
                <button type="button"
                        (click)="selectedCampaign(item.client.id, item.campaign)"
                        class="campaign-button cart-wizard-choice-card">
                    <div class="campaign-block">
                        <div class="campaign-copy">
                            <div class="campaign-name">{{item.campaign.get('name')}}</div>
                            <div class="client-name">{{item.client.fullName}}</div>
                        </div>
                        <div class ="icon">
                            <mat-icon class="campaign-icon">location_city</mat-icon>
                        </div>
                        <span class="campaign-cta blue-button">{{ 'SELECT_LOCATION' | translate }}</span>
                    </div>
                </button>
            </ng-container>
            <button type="button" (click)="addNewCampaign(true)" class="campaign-button cart-wizard-choice-card new-campaign">
                <div class="campaign-block">
                    <div class="campaign-copy">
                        <div class="campaign-name">{{ 'CREATE_A_NEW_CAMPAIGN' | translate }}</div>
                        <div class="client-name client-name--placeholder" aria-hidden="true">{{ 'PLACEHOLDER' | translate }}</div>
                    </div>
                    <div class="new-campaign-icon-container">
                        <mat-icon class="new-campaign-icon">add_business</mat-icon>
                    </div>
                    <span class="campaign-cta orange-button">{{ 'CREATE_LOCATION' | translate }}</span>
                </div>
            </button>
        </div>
        <div class="cart-wizard-section-divider active-campaigns">
            <strong class="cart-wizard-section-divider__title">{{ 'CURRENTLY_ACTIVE_LOCATIONS' | translate }}</strong>
            <p class="cart-wizard-section-divider__copy">{{ 'ACTIVE_LOCATIONS_TIP' | translate }}</p>
        </div>
        <div class="campaign-container">
            <ng-container *ngFor="let item of inactiveCampaigns">
                <button type="button" class="campaign-button cart-wizard-choice-card cart-wizard-choice-card--muted active-block">
                    <div class="campaign-block">
                        <div class="campaign-copy">
                            <div class="campaign-name">{{item.campaign.get('name')}}</div>
                            <div class="client-name">{{item.client.fullName}}</div>
                        </div>
                        <div class="icon red">
                            <mat-icon class="campaign-icon">location_city</mat-icon>
                        </div>
                        <span class="campaign-cta disabled-button">{{ 'ALREADY_ACTIVE' | translate }}</span>
                    </div>
                </button>
            </ng-container>
        </div>
    </ng-container>
</div>
